import {Suspense, lazy} from 'react';
import {useTranslation} from 'react-i18next';
import {useRemoteIVFlow} from 'hooks/iv/ivRemoteFlow';
import {useRemoteStartVerificationLink} from 'hooks/iv/useRemoteStartVerificationLink';
import {useEventListener} from './useEventListener';
import phone from 'assets/img/phone.svg?no-inline';
import {Button} from '@guestapp/old-ui-kit';
import {
  Box,
  Title,
  Info,
  HeaderInfo,
  Header,
  TitleGroup,
  PhoneIcon,
  Content,
  ContentWrapper,
  InfoTitle,
  QRCodeWrapper,
  ListContentWrapper,
  View,
  StyledLoader,
} from './styled';

const QRCodeSVG = lazy(() =>
  import('qrcode.react').then(module => ({default: module.QRCodeSVG})),
);

export const ScanQRCodeView = () => {
  const {t} = useTranslation();
  const {goToDocumentSelection} = useRemoteIVFlow();
  const {generateRemoteStartVerificationLink} = useRemoteStartVerificationLink();
  const {isStartedOnMobile} = useEventListener();

  return (
    <View>
      <Box>
        <Header>
          <PhoneIcon src={phone} />
          <TitleGroup>
            <Title>{t('use_your_phone_to_verify_your_identity')}</Title>
            <HeaderInfo>{t('scan_this_qr')}</HeaderInfo>
          </TitleGroup>
        </Header>
        <Content>
          <Suspense fallback={<StyledLoader visible />}>
            <ContentWrapper>
              <QRCodeWrapper>
                <QRCodeSVG value={generateRemoteStartVerificationLink()} height={152} />
              </QRCodeWrapper>
            </ContentWrapper>
          </Suspense>
          <ListContentWrapper>
            <Info>
              <InfoTitle>{t('scan_qr_code_vew.advantages')}</InfoTitle>
              <ul>
                <li>{t('scan_qr_code_vew.document_photos_and_selfie_quality')}</li>
                <li>{t('scan_qr_code_vew.easiest_and_fastest_method')}</li>
                <li>
                  {t(
                    'scan_qr_code_vew.alternative_in_case_your_computer_doesn_t_have_camera',
                  )}
                </li>
              </ul>
            </Info>
          </ListContentWrapper>
        </Content>
      </Box>
      {!isStartedOnMobile && (
        <>
          <span>{t('or')}</span>
          <Button
            onClick={goToDocumentSelection}
            label={t('continue_in_this_browser')}
            outlined
          />
        </>
      )}
    </View>
  );
};
